export function currentDate() {
	const date = new Date();
	let day = date.getDate();
	let month = date.getMonth() + 1;
	const year = date.getFullYear();

	if (day < 10) {
		day = "0" + day;
	}
	if (month < 10) {
		month = "0" + month;
	}

	const fill = (selector, value) => {
		document.querySelectorAll(selector).forEach((el) => {
			el.textContent = value;
		});
	};

	fill(".sdk-current-day", day);
	fill(".sdk-current-month", month);
	fill(".sdk-current-year", year);
}
